import { SnackbarProvider } from 'notistack';
import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Routes, Route } from 'react-router-dom';

import { Loader } from '../base/components/Loader';
import { SnackbarManager } from '../base/components/SnackBar';
import { Loading } from '../base/enums';
import { useAppDispatch, useAppSelector, useRoutesWithLang } from '../base/hooks';
import { workerAppActions } from './redux/slices/workerAppSlice';

import { Login } from './units/authorization/pages/Login';
import { PasswordRecoveryPage } from './units/authorization/pages/PasswordRecovery';
import { Settings } from './units/settings/pages/Settings';
import { SignUpPage } from './units/authorization/pages/SignUp';
import { ChangeLoginPage } from './units/settings/pages/ChangeLogin';
import { PasswordChangePage } from './units/settings/pages/ChangePassword';
import { SettingsRoutes } from './units/settings/routes';
import { AuthRoutes } from './units/authorization/routes';
import { CreateLoginPage } from './units/settings/pages/CreateLogin';
import { QuickApplyPage } from './units/quick-apply/pages';
import { QuickApplyRoutes } from './units/quick-apply/routes';

export const WorkerApp = () => {
    const {
        app: { loading },
        workerApp: { initialized },
    } = useAppSelector((state) => state);
    const dispatch = useAppDispatch();
    const authRoutes = useRoutesWithLang<typeof AuthRoutes>(AuthRoutes);
    const settingsRoutes = useRoutesWithLang<typeof SettingsRoutes>(SettingsRoutes);
    const quickApplyRoutes = useRoutesWithLang<typeof QuickApplyRoutes>(QuickApplyRoutes);

    useEffect(() => {
        dispatch(workerAppActions.init());
    }, []);

    if (!initialized) {
        return (
            <div className='worker-app'>
                <Loader showLoader={loading === Loading.App} />
            </div>
        );
    }

    return (
        <HelmetProvider>
            <SnackbarProvider maxSnack={10}>
                <div className='worker-app'>
                    <Routes>
                        <Route path={authRoutes.Login} element={<Login />} />
                        <Route path={authRoutes.SignUp} element={<SignUpPage />} />
                        <Route path={authRoutes.PasswordRecovery} element={<PasswordRecoveryPage />} />

                        <Route path={settingsRoutes.Settings} element={<Settings />} />

                        <Route path={settingsRoutes.ChangePassword} element={<PasswordChangePage />} />
                        <Route path={settingsRoutes.ChangeLogin} element={<ChangeLoginPage />} />
                        <Route path={settingsRoutes.CreateLogin} element={<CreateLoginPage />} />

                        <Route path={quickApplyRoutes.Index} element={<QuickApplyPage />} />
                    </Routes>
                    <Loader showLoader={loading === Loading.App} />
                    <SnackbarManager />
                </div>
            </SnackbarProvider>
        </HelmetProvider>
    );
};
